import React from "react";
import {HashLink} from "react-router-hash-link";

/**
 * Adds an anchor link that is accessible for skip to main
 * https://github.com/rafgraph/react-router-hash-link/issues/40#issuecomment-628323783
 */
const AccessibleHashlink = (props) => {
    const focusTarget = () => {
        const route = props.to;
        if (typeof route === 'string') {
            const hashes = route.split('#');
            if (hashes.length > 1) {
                const id = hashes.pop();
                if (id) {
                    const h = `#${id}`;
                    setTimeout(() => {
                        const e = document.querySelector(h);
                        const p = e.parentElement;
                        if (p) {
                            const a = document.createElement('span');
                            a.setAttribute('id', `${h}-insert-point`);
                            a.setAttribute('tabIndex', '0');
                            p.insertBefore(a, e);
                            a.focus();
                            a.addEventListener('blur', () => {
                                p.removeChild(a);
                            })
                        }
                    }, 1);
                }
            } else {
                window.scrollTo({top: 0});
            }
        }
    }

    return (
        <HashLink {...props} onClick={focusTarget} />
    );
}

export default AccessibleHashlink;